import "./navigation";
import "./bacteria";
import throttle from "lodash/throttle";

$(() => {

  // Elements
  const $window = $(window);
  const $body = $("body");
  const $bacteria = $("#bacteria", $body);


  if ($bacteria.length > 0) {

    // vars

    const imageSource = $("#bacteria-image", $bacteria)[0];

    // animate bacteria

    $(".bacteria-monster", $bacteria).toArray().forEach(el => {

      const $el = $(el);

      animateBacteria(el, 500, 20 * 1000, true);

    });

    startCanvas();

    function animateBacteria(el, distance, time, loop) {
      const pos = makeNewPosition(el, distance);
      const target = el.querySelector("i");

      //console.log("loop");

      target.style.transform = `translate(${pos.left}px, ${pos.top}px)`;
      target.style.msTransform = target.style.transform;
      target.style.transitionDuration = time + "ms";
      target.style.msTransitionDuration = time + "ms";
      target.style.opacity = ((Math.random() * 0.4) + 0.8) + "";

      if (loop === true) {
        setTimeout(() => {
          animateBacteria(el, distance, time, true);
        }, time);
      }

    }

    function makeNewPosition(el, distance) {
      // randomly chose number between -50 and +50
      let left = ([-1, 1][Math.random() * 2 | 0]) + Math.floor((Math.random() * distance) + 1);
      let top = ([-1, 1][Math.random() * 2 | 0]) + Math.floor((Math.random() * distance) + 1);

      return {
        top,
        left
      };
    }

    function startCanvas() {
      const canvas = $("#bacteria-canvas", $body)[0];
      let ctx = canvas.getContext("2d");
      let bugsCount = 20;
      let bugs = [];
      let width = 0;
      let height = 0;
      let mX = -100;
      let mY = -100;

      // Events

      $window.resize(throttle(setDimensions, 300));
      $window.scroll(throttle(setDimensions, 300));

      let showPos = throttle(() => {
        console.log("mY", mY);
      }, 1000);

      $body[0].addEventListener("mousemove", throttle(event => {

        mX = event.clientX;
        mY = Math.floor($bacteria.offset().top - event.pageY);

        if (mY > 0) {
          // Mouse is not inside #bacteria / canvas
          mY = -100;
        } else {
          mY = Math.abs(mY);
        }

      }, 1000));

      // Canvas

      /**
       * Set the width and height of the canvas related to the element #bacteria
       */
      function setDimensions() {
        canvas.width = width = $bacteria.outerWidth();
        canvas.height = height = $bacteria.outerHeight();
      }

      function run() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        for (let i = 0; i < bugsCount; i++) {
          let bug = bugs[i],
            x = mX,
            y = mY,
            minDist = 100,
            x2 = bug.x,
            y2 = bug.y;

          let dist = Math.sqrt((x2 - x) * (x2 - x) + (y2 - y) * (y2 - y)),
            dx = x2 - x,
            dy = y2 - y;

          if (dist < minDist) {
            var force = minDist / (dist * dist),
              xcomp = (x - x2) / dist,
              ycomp = (y - y2) / dist,
              deltaV = force / 2;

            bug.velX -= deltaV * xcomp;
            bug.velY -= deltaV * ycomp;

          }
          else {
            bug.velX *= .98;
            if (bug.velY <= bug.speed) {
              bug.velY = bug.speed
            }
            bug.velX += Math.cos(bug.step += .05) * bug.stepSize;
          }

          //ctx.fillStyle = "rgba(255,255,255," + bug.opacity + ")";
          bug.y += bug.velY;
          bug.x += bug.velX;

          if (bug.y >= (canvas.height+200) || bug.y <= -200) {
            reset(bug);
          }


          if (bug.x >= (canvas.width+200) || bug.x <= -200) {
            reset(bug);
          }
          ctx.save();
          ctx.globalAlpha = bug.opacity;
          ctx.translate(bug.x, bug.y);
          ctx.rotate(bug.degrees*Math.PI/180);
          ctx.drawImage(
            imageSource,
            0,
            0,
            bug.size,
            bug.size
          );
          ctx.restore();
        }

        requestAnimationFrame(run);
      }

      function getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
      }

      function reset(bug) {
        let size = (Math.random() * 0.3) + 0.6;

        bug.x = Math.floor(Math.random() * canvas.width);
        bug.y = -80;
        bug.size = Math.floor(imageSource.naturalWidth * (size*0.7));
        //bug.size = (Math.random() * 3) + 2;
        bug.speed = (Math.random() * 0.7) + 0.2;
        bug.velY = bug.speed;
        bug.velX = 0;
        bug.degrees = ([-1, 1][Math.random() * 2 | 0]) + getRandomInt(3, 180);
        bug.opacity = (Math.random() * 0.2) + 0.4;

        //console.log("reset", bug.degrees);
      }

      requestAnimationFrame(run);

      function init() {

        // Generate bacteria
        for (let i = 0; i < bugsCount; i++) {
          let
            x = Math.floor(Math.random() * canvas.width),
            y = Math.floor(Math.random() * canvas.height*2),
            speed = (Math.random() * 0.8) + 0.2,
            opacity = ((Math.random() * 0.2) + 0.3).toFixed(12),
            size = (Math.random() * 0.3) + 0.6
          ;

          bugs.push({
            speed: speed,
            velY: speed,
            velX: 0,
            x: x,
            y: y,
            degrees: ([-1, 1][Math.random() * 2 | 0]) + getRandomInt(3, 180),
            size: Math.floor(imageSource.naturalWidth * size),
            stepSize: (Math.random()) / 30,
            step: 0,
            opacity: opacity
          });
        }

        run();
      }

      setDimensions();
      init();
    }

  }// if #bacteria exists
});


// WEBPACK FOOTER //
// ./js/bacteria.js